import React from 'react';
import classnames from 'classnames';
import { ColumnComponentProps } from 'v2/utils/searchViewUtils';
import { formatDate } from 'v2/utils/dateUtils';

const LastActivity = ({ search }: ColumnComponentProps) => {
  return (
    <div
      className={classnames('text-light3', 'line-height', 'no-wraping-text')}
      data-cy="column:last-activity"
    >
      {formatDate(search.last_internal_update, true)}
    </div>
  );
};

export default LastActivity;
